<template>
  <v-menu v-model="menu" :close-on-content-click="false" min-width="290" max-width="340" offset-y left transition="slide-y-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" class="profile-button" text rounded aria-label="Open user menu">
        <v-avatar size="36" color="white">
          <v-img v-if="currentUser.imageUrl" :src="currentUser.imageUrl" :alt="currentUser.name" />
          <v-icon v-else color="primary" size="23">mdi-account-outline</v-icon>
        </v-avatar>
        <span v-if="$vuetify.breakpoint.mdAndUp" class="profile-copy">
          <span class="profile-name">{{ currentUser.name }}</span>
          <span class="profile-role">{{ userRole }}</span>
        </span>
        <v-icon v-if="$vuetify.breakpoint.mdAndUp" size="17">mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-card class="user-card" elevation="8">
      <v-card-text class="user-summary">
        <v-avatar size="46" color="#F1F8F2">
          <v-img v-if="currentUser.imageUrl" :src="currentUser.imageUrl" :alt="currentUser.name" />
          <v-icon v-else color="primary">mdi-account-outline</v-icon>
        </v-avatar>
        <div class="user-details">
          <div class="user-name">{{ currentUser.name }}</div>
          <div class="user-email">{{ currentUser.email }}</div>
          <v-chip x-small color="primary" outlined class="mt-2">{{ userRole }}</v-chip>
        </div>
      </v-card-text>

      <v-divider />
      <v-list dense class="menu-list">
        <v-list-item to="/account">
          <v-list-item-icon><v-icon color="primary" size="20">mdi-account-cog-outline</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Account settings</v-list-item-title></v-list-item-content>
          <v-list-item-icon><v-icon size="17">mdi-chevron-right</v-icon></v-list-item-icon>
        </v-list-item>
      </v-list>

      <div class="location-code">
        <span>Location code</span><strong>{{ currentBusiness.code }}</strong>
      </div>
      <v-divider />

      <v-card-actions class="menu-actions">
        <ChangePassword :UserId="currentUser.id" />
        <v-spacer />
        <v-btn color="primary" text to="/logout">
          <v-icon left size="18">mdi-logout</v-icon>{{ $t("buttons.logout") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
import ChangePassword from "../../User/components/ChangePassword";

export default {
  name: "layout-menu",
  components: { ChangePassword },
  data() {
    return { menu: false };
  },
  computed: {
    ...mapGetters("global", ["currentUser", "currentBusiness"]),
    userRole() {
      if (this.currentUser.superAdmin) return "Super admin";
      if (this.currentUser.isAdmin) return "Admin";
      return "User";
    },
  },
};
</script>

<style scoped>
.profile-button { height: 48px !important; min-width: 48px !important; padding: 0 8px !important; color: white !important; text-transform: none; }
.profile-copy { display: flex; min-width: 0; max-width: 150px; flex-direction: column; align-items: flex-start; margin: 0 9px; line-height: 1.2; }
.profile-name { overflow: hidden; max-width: 100%; font-size: 13px; font-weight: 650; text-overflow: ellipsis; white-space: nowrap; }
.profile-role { color: rgba(255, 255, 255, .72); font-size: 10px; }
.user-card { border-radius: 12px !important; overflow: hidden; }
.user-summary { display: flex; gap: 13px; padding: 20px; }
.user-details { min-width: 0; }
.user-name { overflow: hidden; color: #253047; font-size: 15px; font-weight: 700; text-overflow: ellipsis; white-space: nowrap; }
.user-email { overflow: hidden; margin-top: 2px; color: #7b8799; font-size: 12px; text-overflow: ellipsis; white-space: nowrap; }
.menu-list { padding: 7px; }
.menu-list .v-list-item { border-radius: 8px; }
.menu-list .v-list-item__icon { margin-right: 13px; }
.location-code { display: flex; align-items: center; justify-content: space-between; margin: 0 14px 10px; padding: 10px 12px; border-radius: 8px; background: #f7f9f7; color: #7b8799; font-size: 12px; }
.location-code strong { color: #2e7d32; letter-spacing: .04em; }
.menu-actions { padding: 9px 12px; }
@media (max-width: 599px) {
  .profile-button { padding: 0 4px !important; }
}
</style>
